<template>
    <div class="contain" v-if="showFlag">
        <div class="alert">
            <h5>{{title}}</h5>
           <p> {{text}}</p>
            <div class="btn btn-primary" @click="close">
                确定
            </div>  
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            showFlag:false,
            text:'do something',
            title:'提示',
            method:''
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {
        close(){
            if(typeof this.method === 'function'){
                this.method()
            }
            this.showFlag = false
        }
    },
    components: {

    },
};
</script>

<style scoped>
    .contain{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
    }
    .alert{
        background: #fff;
        padding: 15px;
        width: 300px;
        border-radius: 7px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        text-align: center;
    }
    .alert h5{
        font-size: 16px;
        color: #333;
        margin: 0;
    }
    .alert p{
        margin: 15px;
    }
    .btn{
        border-radius: 5px;
    }
</style>
